import { SelectInput } from '@core/components/Select';
import React from 'react';

/*
RNE-092 - Preenchimento das formas de pagamento conforme conta : Public <<Functional>> Feature
Created:	20/03/2020 11:52:05
Modified:	20/03/2020 12:00:15
Project:	
Advanced:	
O sistema deverá exibir as formas de pagamento conforme a conta selecionada:
- Quando for selecionada alguma conta que seja do tipo "Caixinha", o sistema só deve exibir na lista a forma de pagamento "Dinheiro".
- Quando for selecionada alguma conta que seja do tipo "Corrente", o sistema deve exibir na lista todas as formas de pagamento, exceto "Dinheiro".
- Quando for selecionada alguma conta que seja do tipo "Poupança", o sistema deve exibir na lista todas as formas de pagamento, exceto "Dinheiro", "Crédito" e "Cheque".

Observação: As contas do tipo "Investimento" não devem ser exibidas na lista.

Tipos de contas :
    CONTA_CORRENTE,
    CONTA_POUPANCA,
    CONTA_INVESTIMENTO,
    CONTA_CAIXINHA,
    CONTA_CARTAO;
*/

export const opcoesFormaDePagamento = [
  { id: 'CARTAO_CREDITO', title: 'Cartão de crédito' },
  { id: 'CARTAO_DEBITO', title: 'Cartão de débito' },
  { id: 'CHEQUE', title: 'Cheque' },
  { id: 'DEBITO_AUTOMATICO', title: 'Débito automático' },
  { id: 'DEBITO_CONTA', title: 'Débito em conta' },
  { id: 'DOC', title: 'DOC' },
  { id: 'TED', title: 'TED' },
  { id: 'TRANSFERENCIA_BANCARIA', title: 'Transferência bancária' },
  { id: 'DINHEIRO', title: 'Dinheiro' },
  { id: 'BOLETO', title: 'Boleto' },
  { id: 'PIX', title: 'Pix' },
  { id: 'OUTRAS', title: 'Outras' },
];

const FormaDePagamento = ({
  id = 'formaPagamento',
  value,
  tipoConta,
  handleChange,
  handleBlur,
  error,
  touched,
  readOnly,
  required,
  disabled,
}) => {
  const opcoes = opcoesFormaDePagamento.filter((option) => {
    if (tipoConta === 'CONTA_CAIXINHA') {
      return option.id === 'DINHEIRO';
    }
    if (tipoConta === 'CONTA_POUPANCA' || tipoConta === 'CONTA_INVESTIMENTO') {
      return option.id !== 'DINHEIRO' && option.id !== 'CARTAO_CREDITO' && option.id !== 'CHEQUE';
    }
    if (tipoConta === 'CONTA_CORRENTE') {
      return option.id !== 'DINHEIRO';
    }
    if (tipoConta === 'CONTA_CARTAO') {
      return option.id === 'CARTAO_CREDITO' || option.id === 'CARTAO_DEBITO';
    }
    return false;
  });

  return (
    <SelectInput
      readOnly={readOnly}
      id={id}
      label="Forma do pagamento"
      fullWidth
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      touched={touched}
      error={error}
      options={opcoes}
      required={required}
      disabled={disabled}
    />
  );
};

export default FormaDePagamento;
